// Development URL'S
// export const BASE_URL: string = 'http://35.154.181.26:8000/api/' //DE PHP base URL
// export const NODE_URL: string = 'http://35.154.181.26:8585'  //(DE Dev Node )
// export const File_base_url:string = 'http://35.154.181.26:8000/storage/'
// export const UI_URL: string = 'http://devseedfund.startupindia.gov.in/'; //(Dev)


// Local Node Url & Php Url
// export const BASE_URL: string = 'http://127.0.0.1:8000/api/' //DE PHP base URL
// export const BASE_URL: string = 'http://35.154.181.26:8087/api/' //Spandana DE PHP base URL
// export const NODE_URL: string = 'http://localhost:3535'  //(Local Node API )

//************************************************************************************/ 
// Seedfund Dev
// export const BASE_URL: string = 'http://dev-sisfs-ext-alb-1867418556.ap-south-1.elb.amazonaws.com/api/' //(SeedFundDev PHP)
// export const NODE_URL: string = 'http://dev-sisfs-ext-alb-1867418556.ap-south-1.elb.amazonaws.com:3535' //(SeedFundDev Dev Node) 
// export const File_base_url:string = 'http://dev-sisfs-ext-alb-1867418556.ap-south-1.elb.amazonaws.com/storage/'
// export const UI_URL: string = 'http://devseedfund.startupindia.gov.in/'; //(Dev)
//************************************************************************************/ 
// Seedfund Prod 
export const BASE_URL:string='https://seedfundapi.startupindia.gov.in/api/' //(Production)
export const NODE_URL: string = 'https://seedfundapi.startupindia.gov.in:3535' //(SeedFundDev Prod Node) 
export const File_base_url:string = 'https://seedfundapi.startupindia.gov.in/storage/'
export const UI_URL:string="https://seedfund.startupindia.gov.in/" //(Production)
//************************************************************************************/ 



// Incubator checkbox download field 
export const EVAL_REMOVE: string = BASE_URL + 'startup/detail/removeFile';
export const CHECK_BOX_DATA: string = BASE_URL + "applications/incubator/downloadExcelFields"
export const INCUBATOR_DOWNLOAD_EXCEL: string = BASE_URL + "applications/incubator/downloadExcel";
export const INCUBATOR_DOWNLOAD_EXCEL_DATA: string = `http://local.api.seedfund.com/ApplicationsdownlodExcel/temp/Incubator_Applications_20220503
190039.xlsx`
// startup Check box download fields
export const STARTUP_CHECK_BOX_DATA: string = BASE_URL + 'applications/startup/downloadExcelFields'
export const STARTUP_DOWNLOAD_EXCEL: string = BASE_URL + 'applications/startup/downloadExcel'
export const INCUBATOR_PREFRENCE_LIST: string = BASE_URL + 'incubator/prefrence/list'
export const INCUBATOR_PREFRENCE_LIST_POST: string = BASE_URL + 'incubator/prefrence/post'
export const INCUBATOR_PREFRENCE_GETLOGS: string = BASE_URL + 'incubator/prefrence/getLogs'
// NODE URL'S:
// export const sec_re_updateTranche: string = NODE_URL + '/api/dpiit/reapply_sec_updateTranche';
export const GET_APPLCAITON_COMMENT_NODE: string = NODE_URL + '/api/meetings/getApplicationComment';
export const GET_ALL_TRANCHES_NODE: string = NODE_URL + '/api/getAllForApplication';
export const GET_APPLICATION_LIST_NODE: string = NODE_URL + '/api/getIncubatorApplications/reapply_inc_list';
export const STORE_TRANCHE_REQUEST_NODE: string = NODE_URL + '/api/incubator/fundDetails/reapply_storeTrancheRequest';
export const GET_ACTIVE_TRANCHE_REQUEST_NODE: string = NODE_URL + '/api/incubator/fundDetails/reapply_getActiveTrancheRequest';
export const GET_Re_TRANCHE: string = NODE_URL + '/api/getAllForApplication'
export const Tranche_amount_Re_update: string = NODE_URL + '/api/dpiit/reapply_sec_updatetranche'
export const MEETINGS_RE_STORE: string = NODE_URL + '/api/dpiit/meetings/reapply_sec_store';
export const QUICK_Re_EDIT: string = NODE_URL + '/api/dashboard/incubator/quickEdit';
export const sec_re_updateTranche: string = NODE_URL + '/api/dpiit/reapply_sec_updateTranche';
export const ADD_TRANCHE_WITH_Re_AMOUNT: string = NODE_URL + '/api/dpiit/addTrancheWithAmount';
export const GET_STORE_INCUBATOR_INFO: string = NODE_URL + '/api/incubator/getincubatorinfo';
export const GET_STORE_INCUBATOR_DATA: string = NODE_URL + '/api/incubator/reapplystore';
export const GET_INCUBATOR_DETAILS_NODE: string = NODE_URL + '/api/dashboard/incubator';
export const GET_RE_APPLICATION_VIEW: string = NODE_URL + '/api/incubator/getreapplylistdtls';
export const GET_Re_APPLICATION_LIST: string = NODE_URL + '/api/incubator/getreapplylist';
export const getsecincubatorslist: string = NODE_URL + '/api/SecReapply_incubator';
export const SecReapplyincubatorapplications: string = NODE_URL + '/api/SecReapply_incubator_applications';
export const GET_Re_QUICK_EDIT: string = NODE_URL + '/api/dashboard/incubator/reapplygetQuickEdit ';
export const DELETE_Re_APPLICATION: string = NODE_URL + '/api/incubator/reapply_draft_applc_del';
export const GET_Re_ALL_INCUBATORS: string = NODE_URL + '/api/reviews/getAllIncubators';
export const GET_SUM_DISBURSED_AMOUNT: string = NODE_URL + '/api/incubator/sum_disbursed_amount';
export const CANCELLATION_Re_REQUEST: string =  NODE_URL + '/api/incubator/reapply_application_cancel';
export const LEGAL_RE_ENTITY: string =  NODE_URL + '/api/incubator/reapply_legal_entity_approval';
export const secappdetailsform3_NODE: string =NODE_URL + '/api/sec_app_detailsform3'
export const secappdetails_RE_FORM2: string =NODE_URL + '/api/sec_app_detailsform2';
export const STORE_BANK_DETAILS_Reapply_Node: string = NODE_URL + '/api/incubator/reapply_bank_details_update';
export const GET_BANK_DETAILS_REAPPLY_NODE: string = NODE_URL + '/api/incubator/get_reapply_bank_details';
export const DOWNLOAD_EXCEL_REAPPLY_TAB: string = BASE_URL + 're-applications/downloadExcel'
export const getApplicationDetails2_3_NODE: string =NODE_URL + '/api/getApplicationDetails2';
export const getApplicationDetails_3_NODE: string =NODE_URL + '/api/getApplicationDetails3';
export const GENERATE_REPORT_RE_EXCEL: string = BASE_URL + 're-applications/incubator/downloadExcel';
export const CHECK_BOX_Re_DATA: string = BASE_URL + 're-applications/incubator/downloadExcelFields'
export const MERGED_BUCKET_COUNT: string = NODE_URL + '/sec_bucketsCount';
export const MERGED_ALL_TABLE_LIST: string = NODE_URL + '/sec_application_list';
export const MERGED_SCHEDULE_MEETING: string = NODE_URL + '/sec_meeting_schedule';
export const mergedfirstapplicationdetails: string = NODE_URL + '/api/sec/merged_first_application_details';
export const mergedsecndapplicationdetails: string = NODE_URL + '/api/dashboard/incubator';
export const getallDocuments: string = NODE_URL + '/api/sec/getallDocuments';
export const getallEACComments: string = NODE_URL + '/api/sec/getallEACComments';
export const secgreybox: string = NODE_URL + '/sec_greybox';
export const secincapplicationdetails: string = NODE_URL + '/sec_inc_application_details';
export const MERGED_COMMENTS: string = NODE_URL + '/api/sec/getallcomments';
export const GET_ALL_INCUBATORS: string = NODE_URL + '/api/reviews/getAllIncubators';
export const MERGED_FUND_DETAILS: string = NODE_URL + '/sec_fundDetails';
export const MERGED_BANK_DETAILS: string = NODE_URL + '/sec_funddetails_bankdetails';
export const ADD_INCUBATOR: string = NODE_URL + '/sec_EAC_view_Addbutton';
export const SELECTED_STARTUP_DOWNLOAD_EXCEL: string = BASE_URL + 'applications/startup/downloadExcel/7'
export const TRANCHES_EDIT: string = NODE_URL + '/sec_funddetails_overalledit';
export const TRANCHE_UPLOAD_SANCTION_NODE: string = NODE_URL + '/sec_funddetails_sancation_upload';
export const NEW_EVALUATION_FILE : string = NODE_URL + '/startup_form_samplefile';
export const SEC_DASHBOARD_COUNT : string = NODE_URL + '/sec_dashboard_bucketcount';
export const GET_ALL_INCUBATORS_NODE : string = NODE_URL + '/sec_dashboard_meetings_view';



export const DOWNLOAD_EXCEL_MERGED: string = BASE_URL + 'all-inc-applications/downloadExcel';


export const LOGIN: string = BASE_URL + 'login';
export const LOGIN_STARTUP: string = BASE_URL + 'investindiaLogin';
export const GET_ALL_STATES: string = BASE_URL + 'getStates';
export const GET_ALL_DISTRICTS: string = BASE_URL + 'getDistrict';
export const STORE_INCUBATOR_APPLICATION: string = BASE_URL + 'incubatorApplication/store';
export const GET_ALL_INDUSTRIES: string = BASE_URL + 'getAttributeData/industry';
export const GET_ALL_INDUSTRY_SECTORS: string = BASE_URL + 'getAttributeData/sector';
export const GET_LEGAL_ENTITY: string = BASE_URL + 'getAttributeData/legal_entity';
export const GET_ASSISTED_INCUBATOR: string = BASE_URL + 'getAttributeData/government_assisted_incubator';
export const GET_ACTIVE_APPLICATION: string = BASE_URL + 'incubatorApplication/activeApplication';
export const FILE_UPLOAD: string = BASE_URL + 'incubatorFiles/upload';
export const FILE_REMOVE: string = BASE_URL + 'incubatorFiles/remove';
export const GET_DPIIT_DASHBOARD_COUNT: string = BASE_URL + 'dashboard/count';
export const GET_DPIIT_DASHBOARD_CHART_COUNT: string = BASE_URL + 'dashboard/incubatorCount';
export const GET_DPIIT_DASHBOARD_CHART_COUNT_STARTUP: string = BASE_URL + 'dashboard/startupCount';
export const GET_INCUBATOR_LISTING_COUNT: string = BASE_URL + 'dashboard/incubator';
export const GET_ALL_SECTOR: string = BASE_URL + 'getAttributeData/sector';
export const GET_ALL_LEGAL_ENTITY: string = BASE_URL + 'getAttributeData/legal_entity';
export const SCHEDULE_MEETING: string = BASE_URL + 'meetings/store';
export const SCHEDULE_MEETING_COUNT: string = BASE_URL + 'meetings/getCounts';
export const GET_MEETING_DETAILS: string = BASE_URL + 'reviews/getMeetingDetails';
export const TRANCHES_STARTUP_EDIT: string = BASE_URL + 'dpiit/editTrancheWithAmount';
export const INCUBATOR_APPLICATION_COUNT : string = NODE_URL + '/sec_dashboard_incApplication_bar';
export const MERGED_FILTER: string = NODE_URL + '/sec_filter_submit';
export const MERGED_FILTER_BUCKET_LIST: string = NODE_URL + '/sec_filter_bucket_list';
export const EAC_VIEW_SEARCH : string = NODE_URL + '/sec_EAC_view_searchbutton';
export const REMOVE_INCUBATOR_NODE : string = NODE_URL + '/sec_EAC_remove_button';


export const REMOVE_INCUBATOR: string = BASE_URL + 'meetings';
export const QUICK_MEETINGS: string = BASE_URL + 'meetings/quick';
export const GET_INCUBATOR_DETAILS: string = BASE_URL + 'dashboard/incubator';
export const GET_APPLICATION_LIST: string = BASE_URL + 'getIncubatorApplications/list';
export const GET_APPLICATION_VIEW: string = BASE_URL + 'incubatorApplication/view';
export const GET_EAC_EVALUATION_QUESTIONS: string = BASE_URL + 'eac/getEvaluationQuestion';
export const SAVE_EAC_EVALUATION_QUESTIONS: string = BASE_URL + 'eac/evaluation';
export const GET_APPLICATION_STATUS: string = BASE_URL + 'getApplicationStatus';
export const QUICK_EDIT: string = BASE_URL + 'dashboard/incubator/quickEdit';
export const ALLOW_INCUBATOR_CREATION: string = BASE_URL + 'incubatorApplication/allowCreation';
export const CONTACT_US: string = BASE_URL + 'contact_us';
export const GET_QUICK_EDIT: string = BASE_URL + 'dashboard/incubator/getQuickEdit';
export const GET_EAC_QUESTION_DETAILS: string = BASE_URL + 'eac/getEvaluationQuestionDetails';
export const CREATE_EMPTY_APPLICATION: string = BASE_URL + 'incubatorApplication/createEmptyApplication';
export const REPLACE_FILE: string = BASE_URL + 'incubatorFiles/replace';
export const DELETE_APPLICATION: string = BASE_URL + 'incubatorApplication/delete';
export const COUNT_SUBIMTTED: string = BASE_URL + 'incubatorApplication/countSubmitted';
export const GET_MEETINGS: string = BASE_URL + 'incubator/meetings';
export const GET_MEETINGS_BY_ID: string = BASE_URL + 'meetings/getById';
export const UPDATE_MEETING: string = BASE_URL + 'meetings/updateById';
export const EAC_REVIEW_UPDATE: string = BASE_URL + 'meetings/eacReveiwUpdate';
export const INCUBATOR_SEARCH: string = BASE_URL + 'meetings/incubatorSearch';
export const MEETING_FILE_UPLOAD: string = BASE_URL + 'meetings/upload';
export const MEETING_FILE_REMOVE: string = BASE_URL + 'meetings/remove';
export const PENDING_INCUBATOR_COUNT: string = BASE_URL + 'meetings/pendingIncubatorCount';
export const TRANCHE_UPLOAD_DOCUMENT: string = BASE_URL + 'incubator/fundDetails/uploadDocument';
export const TRANCHE_REMOVE_DOCUMENT: string = BASE_URL + 'incubator/fundDetails/removeDocument';
export const STORE_TRANCHE_REQUEST: string = BASE_URL + 'incubator/fundDetails/storeTrancheRequest';
export const GET_TRANCHE_REQUEST: string = BASE_URL + 'incubator/fundDetails/getTrancheRequest';
export const SAVE_APPLCAITON_COMMENT: string = BASE_URL + 'meetings/saveApplicationComment ';
export const GET_APPLCAITON_COMMENT: string = BASE_URL + 'meetings/getApplicationComment';
export const EVALUATION_FILE: string = BASE_URL + 'evaluation-file';
export const FULL_REPORT: string = BASE_URL + 'dashboard/fullReport';
export const STORE_BANK_DETAILS: string = BASE_URL + 'incubator/bankDetails/post';
export const GET_BANK_DETAILS: string = BASE_URL + 'incubator/bankDetails/get';
export const GRIEVANCE_STORE: string = BASE_URL + 'grievance/store';
export const ADD_MORE_TRANCHE: string = BASE_URL + 'dpiit/addMoreTranche';
export const UPDATE_TRANCHE: string = BASE_URL + 'dpiit/updateTranche';
export const GET_TRANCHE_STATUS: string = BASE_URL + 'tranche/getStatus';
export const ADD_TRANCHE_WITH_AMOUNT: string = BASE_URL + 'dpiit/addTrancheWithAmount';
export const GET_TRANCHE_BY_APPLICATION_ID: string = BASE_URL + 'tranche/getAllForApplication';
export const NEWSLETTER_SUBSCRIBE: string = BASE_URL + 'newsletter/subscribe';
export const DPIIT_TRANCHE: string = BASE_URL + 'dpiit/tranche';
export const INCUBATOR_FUNDDETAILS: string = BASE_URL + 'incubator/fundDetails';
export const GET_ALL_TRANCHES: string = BASE_URL + 'tranche/getAllForApplication';
export const GET_ACTIVE_TRANCHE_REQUEST: string = BASE_URL + 'incubator/fundDetails/getActiveTrancheRequest';
export const GRAPH: string = BASE_URL + 'dashboard/graph';
export const FORGOT_PASSWORD: string = BASE_URL + 'forgot-password';
export const RESET_PASSWORD: string = BASE_URL + 'reset-password';
export const ACCOUNT_DOCUMENT_UPLOAD: string = BASE_URL + 'incubator/bankDetails/upload';
export const ACCOUNT_DOCUMENT_REMOVE: string = BASE_URL + 'incubator/bankDetails/remove';
export const STORE_STARTUP_APPLICATION: string = BASE_URL + 'startup';
export const STARTUP_ALL_APPLICATIONS: string = BASE_URL + 'startupMyApplications';
export const STARTUP_FILE_UPLOAD: string = BASE_URL + 'startup/file/upload';
export const STARTUP_FILE_REMOVE: string = BASE_URL + 'startup/file/remove';
export const STARTUP_GET_INCUBATORS: string = BASE_URL + 'startup';
export const GET_STARTUP_MEETINGS: string = BASE_URL + 'startup/meetings/getMeetingDetails';
export const EXPENSE_BUCKET_OPTION: string = BASE_URL + 'startup/expenseBucketOptions';
export const GET_STARTUP_ELIGIBILITY: string = BASE_URL + 'startup/eligibility';
export const GET_GRIEVANCE_LIST: string = BASE_URL + 'grievance/list';
export const REGISTER_USER: string = BASE_URL + 'admin/register';
export const USER_LIST: string = BASE_URL + 'admin/list';
export const CONTACT_LIST: string = BASE_URL + 'contact/data';
export const GRIEVANCE_DETAILS: string = BASE_URL + 'grievance/detail';
export const ADD_COMMENT: string = BASE_URL + 'grievance/comment';
export const EDIT_STATUS: string = BASE_URL + 'grievance/statusChange';
export const USER_ACTIVE_INACTIVE: string = BASE_URL + 'admin/activeInactive';
export const GET_STARTUP_LISTING: string = BASE_URL + 'dashboard/startup/applications';
export const GET_STARTUP_LISTING_FILTER: string = BASE_URL + 'dashboard/startup/application';
export const STARTUP_SCHEDULE_MEETING: string = BASE_URL + 'startup/meetings/store';
export const STARTUP_MEETING_GET_BY_ID: string = BASE_URL + 'startup/meetings/getById';
export const STARTUP_MEETING_UPDATE_BY_ID: string = BASE_URL + 'startup/meetings/updateById';
export const GET_ALL_STARTUPS: string = BASE_URL + 'startup/meetings/getAllStartups';
export const STARTUP_SEARCH: string = BASE_URL + 'startup/meetings/startupsSearch';
export const STARTUP_DOCUMENT_UPLOAD: string = BASE_URL + 'startup/meetings/uploadFile';
export const STARTUP_DOCUMENT_REMOVE: string = BASE_URL + 'startup/meetings/removeFile';
export const VIEW_STARTUP_APPLICATION: string = BASE_URL + 'startup/app_detail';
export const REVIEW_UPDATE: string = BASE_URL + 'startup/meetings/reveiwUpdate';
export const GET_STARTUP_APPLICATION_STATUS: string = BASE_URL + 'startup/getStatus';
export const GET_STARTUP_ENGAGEMENT_STATUS: string = BASE_URL + 'startup/getEngagementStatus';
export const CANCELLATION_REQUEST: string = BASE_URL + 'incubator/cancel/raise';
export const STARTUP_GET_BANK_DETAILS: string = BASE_URL + 'startup/bankDetails/get';
export const STARTUP_STORE_BANK_DETAILS: string = BASE_URL + 'startup/bankDetails/post';
export const STARTUP_ACCOUNT_DOCUMENT_UPLOAD: string = BASE_URL + 'startup/bankDetails/upload';
export const INCUBATOR_CANCEL_DETAIL: string = BASE_URL + 'incubator/cancel/detail';
export const STARTUP_ADD_TRANCHE_WITH_AMOUNT: string = BASE_URL + 'startup/addTrancheWithAmount';
export const CANCEL_STATUS_UPDATE: string = BASE_URL + 'incubator/cancel/dpiitComment';
export const CANCEL_DATE_UPDATE: string = BASE_URL + 'incubator/cancel/dpiitUpdateDateFund';
export const GET_ALL_STARTUP_TRANCHES: string = BASE_URL + 'startup/getAllTranchesForApplication';
export const UPDATE_FILE_CANCELLATION: string = BASE_URL + 'incubator/cancel/dpiitUploadProofFund';
export const STARTUP_STORE_TRANCHE_REQUEST: string = BASE_URL + 'startup/storeTrancheRequest';
export const STARTUP_GET_ACTIVE_TRANCHE_REQUEST: string = BASE_URL + 'startup/getActiveTrancheRequest';
export const NOTIFICATION_LIST: string = BASE_URL + 'notification/list';
export const NOTIFICATION_LIST_STATUS_CHANGE: string = BASE_URL + 'notification/statusChange';
export const STARTUP_TRANCHE_UPLOAD_DOCUMENT: string = BASE_URL + 'startup/uploadTrancheDocument';
export const STARTUP_TRANCHE_REMOVE_DOCUMENT: string = BASE_URL + 'startup/removeTrancheDocument';
export const STARTUP_UPDATE_TRANCHE: string = BASE_URL + 'startup/updateTranche';
export const NOTIFICATION_LIST_STATUS_CHANGE_ALL: string = BASE_URL + 'notification/statusChangeAll';
export const STARTUP_GET_TRANCHE_STATUS: string = BASE_URL + 'startup/getTrancheStatus';
export const CANCELLATION_REQUEST_STARTUP: string = BASE_URL + 'startup/cancel/raise';
export const UPLOAD_DISBURSEMENT_PROOF: string = BASE_URL + 'incubator/cancel/UploadDisbursementProof';
export const STARTUP_ADD_COMMENT: string = BASE_URL + 'startup/tranche';
export const STARTUP_CANCELLATION_DETAIL: string = BASE_URL + 'startup/cancel/details';
export const CANCEL_STATUS_UPDATE_StARTUP: string = BASE_URL + 'startup/cancel/incubatorComment';
export const CANCEL_DATE_UPDATE_INCUBATOR: string = BASE_URL + 'startup/cancel/incubatorUpdateDateFund';
export const UPDATE_FILE_CANCELLATION_INCUBATOR: string = BASE_URL + 'startup/cancel/incubatorUploadProofFund';
export const UPLOAD_DISBURSEMENT_PROOF_STARTUP: string = BASE_URL + 'startup/cancel/UploadDisbursementProof';
export const UPLOAD_FILE: string = BASE_URL + 'startup/detail/uploadFiles';
export const UPLOAD_FILE1: string = BASE_URL + 'startup/detail/uploadFilesMultiple';
export const PENDING_STARTUP_COUNT: string = BASE_URL + 'startup/meetings/pendingStartupsCount';
export const SCHEDULE_MEETING_COUNT_STARTUP: string = BASE_URL + 'startup/meetings/getCounts';
export const QUICK_STARTUP_MEETING: string = BASE_URL + 'startup/meetings/quick';
export const STARTUP_GET_DETAILS: string = BASE_URL + 'startupGetEntityDetail';
export const GET_TOP_INCUBATORS: string = BASE_URL + 'dashboard/topIncubators';
export const GET_APPLICATION_COMMENT_STARTUP: string = BASE_URL + 'startup/meetings/getApplicationComment';
export const SAVE_MEETING_COMMENT_STARTUP: string = BASE_URL + 'startup/meetings/saveApplicationComment';
export const PROGRESS_OVERVIEW_DETAIL_BY_APPLICATION_ID: string = BASE_URL + 'startup/progressOverview/get?startup_application_id='
export const PROGRESS_PERCENTAGE: string = BASE_URL + 'startup/progressOverview/percentage'
export const PROGRESS_STAGES: string = BASE_URL + 'startup/progressOverview/stages'
export const PROGRESS_OVERVIEW_FORM: string = BASE_URL + 'startup/progressOverview'
export const PROGRESS_OVERVIEW_EDIT_FORM: string = BASE_URL + 'startup/progressOverview/updateRow'
export const PROGRESS_OVERVIEW_VALIDATE: string = BASE_URL + 'startup/progressOverview/approve'
export const PROGRESS_DATA_BY_PROGRESS_ID: string = BASE_URL + 'startup/progressOverview/getById'
export const STARTUP_DETAIL_UPLOAD: string = BASE_URL + 'startup/detail/uploadFiles'
export const DOWNLOAD_EXCEL: string = BASE_URL + 'applications/downloadExcel'
export const GRAPH_BAR: string = BASE_URL + 'dashboard/startupGraph'
export const GET_PORTFOLIO: string = BASE_URL + 'portfolio'
export const GET_PORTFOLIO_DETAIL: string = BASE_URL + 'portfolio/detail/'
export const SHOW_DASHBOARD: string = BASE_URL + 'incubator/dashboard'
export const CONTACT_STATE: string = BASE_URL + 'getContactUsStates'
export const CONTACT_CITY: string = BASE_URL + 'getCountactusDistrict'
export const TRANCHE_UPLOAD_SANCTION: string = BASE_URL + 'dpiit/tranche/uploadSanction'
export const TRANCHE_FILE_REMOVE: string = BASE_URL + 'dpiit/tranche/remove';
export const PROGRESS_OVERVIEW_FILE_UPLOAD: string = BASE_URL + 'startup/progressOverview/upload'

export const RE_CANCEL_STATUS_UPDATE: string = BASE_URL + 're-incubator/cancel/dpiitComment';
export const RE_CANCEL_DATE_UPDATE: string = BASE_URL + 're-incubator/cancel/dpiitUpdateDateFund';
export const RE_INCUBATOR_CANCEL_DETAIL: string = BASE_URL + 're-incubator/cancel/detail';
export const RE_UPDATE_FILE_CANCELLATION: string = BASE_URL + 're-incubator/cancel/dpiitUploadProofFund';

export const Re_TRANCHE_UPLOAD_DOCUMENT: string = BASE_URL + 're-incubator/fundDetails/uploadDocument';

